var _title, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSearch = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "57B780ED-9CAC-4557-88DB-BEA2E0FCD59E")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-",
    transform: "translate(-528.000000, -24.000000)",
    fill: "#4B4B4A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M537,24 C541.970563,24 546,27.9781123 546,32.8853625 C546,35.2053404 545.099392,37.3176495 543.624507,38.9001154 L545.057661,40.3146375 C545.448185,40.7001875 545.448185,41.3252875 545.057675,41.7108522 C544.667136,42.0963875 544.033971,42.0963875 543.643447,41.7108375 L542.112147,40.1991559 C540.660203,41.1902144 538.898769,41.770725 537,41.770725 C532.029437,41.770725 528,37.7926127 528,32.8853625 C528,27.9781123 532.029437,24 537,24 Z M537,25.974525 C533.134007,25.974525 530,29.0686123 530,32.8853625 C530,36.7021127 533.134007,39.7962 537,39.7962 C540.865993,39.7962 544,36.7021127 544,32.8853625 C544,29.0686123 540.865993,25.974525 537,25.974525 Z",
    id: "Combined-Shape"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/search.3c47fe42.svg";
export { ForwardRef as ReactComponent };